// Feature overview — lead → offert → projekt → vinst as horizontal flow
const Features = () => {
  const steps = [
    {
      n: "01",
      t: "Affärer",
      h: "Inga förfrågningar mellan stolarna",
      bullets: ["Automatisk fördelning till rätt person", "Påminnelser till avslut", "Få förfrågningar automatiskt"],
    },
    {
      n: "02",
      t: "Offert",
      h: "Räkna rätt — varje gång",
      bullets: ["AI föreslår rader från liknande projekt", "ROT-avdrag & moms räknas automatiskt", "E-signatur direkt från Byggro"],
    },
    {
      n: "03",
      t: "Projekt",
      h: "Håll budget och tidplan",
      bullets: ["Se budget vs utfall per fas i realtid", "ÄTA-arbeten spåras och faktureras direkt", "Avvikelser flaggas innan de äter marginalen"],
    },
    {
      n: "04",
      t: "Vinst",
      h: "Vet vad du tjänade — innan bokslutet",
      bullets: ["Se vilka jobb som faktiskt tjänar pengar", "AI visar mönster i lönsamhet per jobbtyp och team", "Fatta beslut på data — inte magkänsla"],
    },
  ];

  return (
    <section className="section" id="funktioner">
      <div className="container">
        <div className="section-head">
          <h2 style={{ maxWidth: 760 }}>Ett flöde, enkelt system. Affärer, offerter, projekt och AI-stöd — i samma system.</h2>
          <p className="lede" style={{ marginTop: 18 }}>
            Byggro hjälper dig som driver firma att spara tid och tjäna mer pengar — med ett system som är smart och hjälper dig hålla ihop affärer, räkna
            snabbt på offerter och vinstdriva projekt från start till slut.
          </p>
        </div>

        <div className="flow">
          {steps.map((s, i) => (
            <div key={s.n} className="flow-step">
              <div className="flow-head">
                <span className="flow-num mono">{s.n}</span>
                <span className="flow-title">{s.t}</span>
                {i < steps.length - 1 && <span className="flow-arr">→</span>}
              </div>
              <h3 style={{ marginTop: 18, fontSize: 20, lineHeight: 1.25 }}>{s.h}</h3>
              <ul className="flow-bullets">
                {s.bullets.map((b) => (
                  <li key={b}>{b}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

Object.assign(window, { Features });
